import { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DrawerBox from './DrawerBox';
import { Image } from 'antd';
import { isAuthenticated } from '../utilities';
import GraduateIcon from '../assets/images/graduate-icon.svg';
import HomeIcon from '../assets/images/Home-icon.svg';
import { useHistory } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { MessageOutlined, PlaySquareOutlined, HomeOutlined, LoginOutlined, PlayCircleOutlined, LogoutOutlined } from '@ant-design/icons';
import { redirectToOmnicuris } from '../utilities';
import { HelpIcon } from '../utilities/resources';
import { LogoBig } from '../utilities/resources';
import EducationIcon from '../assets/images/graduate-icon.svg';
import play from '../assets/images/play.png';
import qualification from '../assets/images/qualification.png';
import home from '../assets/images/home.png';
import login from '../assets/images/login.png';
import Img from './Img';
import { DefaultProfileIcon } from '../utilities/resources';
import { INITIATE_AUTH_DRAWER } from '../actions/types';

export const LoginIconColor = 'https://s3.ap-southeast-1.amazonaws.com/omnicuris.assets/prod/new-cme/login-color.png';
export const PracticeIconColor = 'https://s3.ap-southeast-1.amazonaws.com/omnicuris.assets/prod/new-cme/practice_speciality.png';
export const MCIIconColor = 'https://s3.ap-southeast-1.amazonaws.com/omnicuris.assets/prod/new-cme/registration_certificate.png';
export const ConferenceIconColor = 'https://s3.ap-southeast-1.amazonaws.com/omnicuris.assets/prod/new-cme/conference-color.png';

function Hamburger(props) {
  const { openHamburger, closeHamburger, logout, login, profilePendingStepsInfo, profileCompletionInfo, showNeedHelpPopup, webinarTabVisible } = props;
  const { userDetails } = useSelector((state) => state.profile);
  const history = useHistory();
  const dispatch = useDispatch();
  const { domainDetails, status } = useSelector((state) => state.listings);

  return (
    <DrawerBox title='' visible={openHamburger} setVisible={closeHamburger} className='hamburger' placement='left' bodyStyle={{ padding: 0 }}>
      <section id='hamburgerBody'>
        <div>
          {domainDetails && domainDetails.orgType === 'certifier' && (
            <div className='hamburgerNavItems'>
              <a className='mob-oc-logo'>
                <h4 id='oc-h4'>Powered By</h4>
                <img style={{ height: '48px' }} src={LogoBig} className='section_right_logo' alt='logo' />
              </a>
            </div>
          )}
          {isAuthenticated() && userDetails.users && (
            <section
              className='usersInfo'
              onClick={() => {
                closeHamburger();
                history.push('/profile');
              }}
            >
              <div className='userDpWrapper'>
                <div className='userDp'>
                  <Img src={userDetails.users.profilePic} defaultSrc={DefaultProfileIcon} alt={`${userDetails.users.firstName} ${userDetails.users.lastName}`} />
                  {profilePendingStepsInfo}
                </div>
                <div className='gridColumn'>
                  <h3>{`${userDetails.users.title} ${userDetails.users.firstName} ${userDetails.users.lastName}`}</h3>
                  {profileCompletionInfo}
                </div>
              </div>
              {userDetails.users.qualification && (
                <p>
                  <img src={GraduateIcon} alt='' />
                  {userDetails.users.qualification}
                </p>
              )}
              {userDetails.users.location && (
                <p>
                  <img src={HomeIcon} alt='' />
                  {userDetails.users.location}
                </p>
              )}
            </section>
          )}

          <nav id='hamburgerNav'>
            {!isAuthenticated() && (
                <div onClick={login} className='hamburgerNavItems mobileNav'>
                  <img src={LoginIconColor} alt='' />
                  Login / Sign Up
                </div>
            )}
            {domainDetails && domainDetails.orgType === 'certifier' && (
              <Fragment>
                <div
                  className='hamburgerNavItems mobileNav'
                  onClick={() => {
                    history.push('/');
                    closeHamburger();
                  }}
                >
                  <img src={ConferenceIconColor} alt='' />
                  Home
                </div>
                <div
                  className='hamburgerNavItems mobileNav'
                  onClick={() => {
                    history.push('/cme');
                    closeHamburger();
                  }}
                >
                  <img src={MCIIconColor} alt='' />
                  CMEs
                </div>
                <div
                  className='hamburgerNavItems mobileNav'
                  onClick={() => {
                    history.push('/webinars');
                    closeHamburger();
                  }}
                >
                  <img src={PracticeIconColor} alt='' />
                  Webinars
                </div>
              </Fragment>
            )}
          </nav>
        </div>
        {/* <div className='help' onClick={() => showNeedHelpPopup(true)}>
          <MessageOutlined />
          Help
        </div> */}
        <div>
          <div
            onClick={() => {
              closeHamburger();
              showNeedHelpPopup(true);
            }}
            className='help'
          >
            <MessageOutlined />
            Need Help?
          </div>
          {isAuthenticated() ? (
            <div
              className='logout'
              onClick={() => {
                closeHamburger();
                logout();
              }}
            >
              <LogoutOutlined />
              Logout
            </div>
          ) : null}
        </div>
      </section>
    </DrawerBox>
  );
}

export default Hamburger;
